export default __webpack_public_path__ + "static/media/GeneralViewSection.ecfb426f.svg";